import React from "react";

import styles from "./NewSellerSubscribeForm.module.css";

import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

const NewSellerSubscribeForm = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography variant="body2" gutterBottom>
          Bạn sẽ nhận được những thông tin giảm giá và sản phẩm mới hàng tuần!
        </Typography>
      </div>
      <div className={styles.action_container}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={10}>
            <TextField
              label="Email của bạn"
              className={styles.tf_subscribe}
              color="secondary"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              className={styles.btn_subscribe}
            >
              SUBSCRIBE
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default NewSellerSubscribeForm;
